import { ALLY_ACCENT_PURPLE, ALLY_ACCENT_PURPLE_HOVER, ALLY_TRANSFER_MODAL_URL } from './constants';

export type TransferPartnerConfig = Readonly<{
  partnerId: 'ally' | 'revolut';
  partnerDisplayName: string;
  brandColor: string;
  brandColorHover: string;
  ctaUrl: string;
  /** APY rate displayed for interest-based partners (e.g. '4.00%' for Revolut). */
  apyRate?: string;
}>;

const ALLY_CONFIG: TransferPartnerConfig = {
  partnerId: 'ally',
  partnerDisplayName: 'Ally',
  brandColor: ALLY_ACCENT_PURPLE,
  brandColorHover: ALLY_ACCENT_PURPLE_HOVER,
  ctaUrl: ALLY_TRANSFER_MODAL_URL,
};

// Placeholder values — update with official Revolut brand assets before launch.
const REVOLUT_CONFIG: TransferPartnerConfig = {
  partnerId: 'revolut',
  partnerDisplayName: 'Revolut',
  brandColor: '#0666EB',
  brandColorHover: '#0452bc',
  ctaUrl: 'https://revolut.ngih.net/c/1381352/3959234/9626',
  apyRate: '4.00%',
};

const CONFIGS: Record<TransferPartnerConfig['partnerId'], TransferPartnerConfig> = {
  ally: ALLY_CONFIG,
  revolut: REVOLUT_CONFIG,
};

export const getTransferPartnerConfig = (partnerId: string): TransferPartnerConfig | null => CONFIGS[partnerId as TransferPartnerConfig['partnerId']] ?? null;
